/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {auditTime} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class AppService {
    private documentClickSubject = new Subject<Event>();
    private windowResizeSubject = new Subject<Event>();
    private backgroundBlurSubject = new Subject<boolean>();
    private routerOutletContainerScrollSubject = new Subject<Event>();
    private updateAlertConfigData = new Subject<boolean>();
    private readonly windowResizeTimeoutMs = 67;

    get onClick(): Observable<Event> {
        return this.documentClickSubject.asObservable();
    }

    get onWindowResize(): Observable<Event> {
        return this.windowResizeSubject.asObservable()
.pipe(auditTime(this.windowResizeTimeoutMs));
    }

    get onRouterOutletContainerScroll(): Observable<Event> {
        return this.routerOutletContainerScrollSubject.asObservable();
    }

    get onShowBackgroundBlur(): Observable<boolean> {
        return this.backgroundBlurSubject.asObservable();
    }


    get onAlertConfigUpdateData(): Observable<boolean> {
        return this.updateAlertConfigData.asObservable();
    }

    emitDocumentClick(event: Event): void {
        this.documentClickSubject.next(event);
    }

    emitWindowResize(event: Event): void {
        this.windowResizeSubject.next(event);
    }

    emitRouterOutletContainerScroll(event: Event): void {
        this.routerOutletContainerScrollSubject.next(event);
    }

    emitShowBackgroundBlur(event: boolean): void {
        this.backgroundBlurSubject.next(event);
    }

    emitAlertConfigUpdateData(event: boolean): void {
        this.updateAlertConfigData.next(event);
    }
}
